import React, { useState, useEffect, useCallback, useRef } from 'react';
import { BrowserRouter } from 'react-router-dom';
import singleSpaReact from 'single-spa-react';
import OAuth from './oauth';
import generateLogoutUrl from './generateLogoutUrl';
import OAuthFlow from './components/OAuthFlow';
import RefreshToken from './components/RefreshToken';
import CurrentUser from './components/CurrentUser';
import IdleTracker from './components/IdleTracker';
import { accessToken, useAccessToken, AccessToken, currentUser } from '@alli/frontend-common';

const isDev = process.env.NODE_ENV === 'development'; // eslint-disable-line no-undef

export default function AlliAuth({ document }) {
    // ref so get a consistent value that doesn't cause re-renders
    const oauthRef = useRef(null);
    if (null === oauthRef.current) {
        oauthRef.current = new OAuth();
    }

    // callback to set the access token in the observable, has to be inside
    // useCallback so it's only generated once
    const setAccessToken = useCallback(response => {
        accessToken.next(AccessToken.fromTokenResponse(response));
    }, []);

    const currentAccessToken = useAccessToken();

    const redirect = useCallback(url => document.location.assign(url), [document]);

    const reload = useCallback(() => document.location.reload(), [document]);

    const logout = useCallback(() => {
        const logoutUrl = generateLogoutUrl(document.location);
        if (isDev) {
            console.warn(`Logging out: ${logoutUrl}`);
        } else {
            document.location.assign(logoutUrl);
        }
    }, [document]);

    return (
        <BrowserRouter>
            <OAuthFlow
                redirect={redirect}
                oauth={oauthRef.current}
                accessToken={accessToken}
                setAccessToken={setAccessToken}
                currentAccessToken={currentAccessToken}
            />
            <RefreshToken
                oauth={oauthRef.current}
                currentAccessToken={currentAccessToken}
                setAccessToken={setAccessToken}
            />
            <CurrentUser
                currentUser={currentUser}
                currentAccessToken={currentAccessToken}
                reload={reload}
            />
            <IdleTracker logout={logout} />
        </BrowserRouter>
    );
}
